import React from 'react';
import { useTheme, SxProps, Theme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ViewDayOutlinedIcon from '@mui/icons-material/ViewDayOutlined';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import TodayIcon from '@mui/icons-material/Today';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export enum IconName {
  ViewDay = 'view-day',
  Sort = 'sort',
  Today = 'today',
  ArrowDown = 'keyboard-arrow-down',
  Calculate = 'calculate',
  FileDownload = 'file-download',
  Info = 'info',
  Edit = 'edit',
}

type MuiIconProps = {
  icon?: IconName;
  sx?: SxProps<Theme>;
};

export const CustomIcon = ({ icon, sx }: MuiIconProps) => {
  const { palette } = useTheme();

  switch (icon) {
    case IconName.ViewDay:
      return (
        <ViewDayOutlinedIcon sx={{ color: palette.text.primary, ...sx }} />
      );
    case IconName.Sort:
      return <SortOutlinedIcon sx={{ color: palette.text.primary, ...sx }} />;
    case IconName.Today:
      return <TodayIcon sx={{ color: palette.text.primary, ...sx }} />;
    case IconName.ArrowDown:
      return (
        <KeyboardArrowDownIcon sx={{ color: palette.text.primary, ...sx }} />
      );
    case IconName.Calculate:
      return (
        <CalculateOutlinedIcon sx={{ color: palette.text.primary, ...sx }} />
      );
    case IconName.FileDownload:
      return (
        <FileDownloadOutlinedIcon sx={{ color: palette.text.primary, ...sx }} />
      );
    case IconName.Info:
      return <InfoOutlinedIcon sx={{ color: palette.text.primary, ...sx }} />;
    case IconName.Edit:
      return <EditOutlinedIcon sx={{ color: palette.text.primary, ...sx }} />;
    default:
      return null;
  }
};
